export const BaseUrl = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'https://us-central1-csmg-a0cd2.cloudfunctions.net/';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'https://us-central1-proteams-stage.cloudfunctions.net/';
  else return 'https://us-central1-csmg-dev-dc546.cloudfunctions.net/';
}());

// console.log("BaseUrl1>>", BaseUrl1);
// export const BaseUrl = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://us-central1-csmg-a0cd2.cloudfunctions.net/' : 'https://us-central1-csmg-dev-dc546.cloudfunctions.net/';

export const DOMAINURL = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'proteams.io';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stage.proteams.io';
  else return 'dev.proteams.io';
}());
// export const DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'proteams.io' : 'dev.proteams.io';

export const APP_DOMAINURL = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'https://appview.proteams.io/auth/loginweb/';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'https://appviewstage.proteams.io/auth/loginweb/';
  else return 'https://appviewdev.proteams.io/auth/loginweb/';
}());

// export const APP_DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://appview.proteams.io/auth/loginweb/' : 'https://appviewdev.proteams.io/auth/loginweb/';

// export const APP_DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://appview.proteams.io/auth/loginweb/' : 'http://localhost:5173/auth/loginweb/';
// export const APP_DOMAINURL = 'http://localhost:5173/auth/loginweb/';

export const ISSUE_DOMAIN = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'http://issues.proteams.io/';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'http://issuesstage.proteams.io/';
  else return 'http://issuesdev.proteams.io/';  
}());
// export const ISSUE_DOMAIN = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'http://issues.proteams.io/' : 'http://issuesdev.proteams.io/';

export const EMP_DOMAIN = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'emp.proteams.io';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stageemp.proteams.io';
  else return 'devemp.proteams.io';  
}());

export const DOMAINURL_SUPPIESEMAIL = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'emp.proteams.io';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stageemp.proteams.io';
  else return 'devemp.proteams.io';  
}());

// export const DOMAINURL_SUPPIESEMAIL = 'devemp.proteams.io';
export const STRIPE_ENDPOINT_SECRETE = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'whsec_gTGOXIqblZW0F87cz1MoHZlM0fl5Vo04';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'whsec_uW3BjToCw3NfOAxyW1l6rZXGZgza9D4a';
  else return 'whsec_Va6KDnAB8G3v2MjS0MrmKC4WM8gtZSQI';
}());

export const STRIPE_SECRETE = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return "sk_live_hMIp1Ca1sLcoFYXobWknLlwH";
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return "sk_test_51Rg4PRHG9KfCFcBthZHUEfJxKzVxuz1yq93X8cliPHyMZ0IypoMVCycMXjesiHkwrYD2uoAlsRuo8xtg0kgN0ZrD00ESU32ipF";
  else return "sk_test_51QolonH54HzvHwSdfN9OGhLFc7xOG5IdU5u1qkhw5a61ynFvfTRL5xrDsWsrZn5Bqe04H8nmcy5dXH9fREMfEP8W00j2s6HjZD";  
}());

export const STRIPE_PUBLISHABLE_KEY = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return "pk_live_hvv5UmbR94gm8iohLexOUmMv";
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return "pk_test_51Rg4PRHG9KfCFcBt5KS1SMQx4kaeSNSUlA3dEl1dUTFCHbblzIHaIoCnJ7Sexak8Rk20OrfJ47iNpZB2GdDyGsOj00e78ijdYO";
  else return "pk_test_51QolonH54HzvHwSd8n5NUVjDwwvNARYiqOSuevqY7Lm4keygUoTyYP4jNqdakAA27bgMhVVkBx69569QVyfH30pt001GdH8UbX";  
}());

export const STRIPE_CLIENT_ID = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "stage") return "ca_SjSlkBhtmPqFXcLdbkQZre08KAXGeeVc";
  else return "ca_SeZW9nSK0lRWPCpS6gOZxmLEUchLfjTk";
}());

export const SENDER_EMAIL = "proteams.io@procleanings.com";

export const APP_STORE_ID = "apps.apple.com/us/app/proteams-io/id1638524286";

export const PLAY_STORE_ID = "play.google.com/store/apps/details?hl=en_US&id=co.csm.procleaning";

export const ROLES = {
  CLIENT: 'Client',
  EMPLOYEE: 'Employee',
  ADMIN: 'admin',
  SUPPORT: 'support',
  SUPERUSER: 'superUser',
  COMPANYUSER: 'companyUser'
};

export const EMP_ROLES = {
  CLIENT_TEAM: 'Client Team',
  ADMIN: 'Admin',
  GUEST: 'Guest',
  SUPPORT: 'Support'
};
export const COLLECTIONS = {
  USERS: 'users',
  EMPLOYEE: 'employees',
  GROUPS: 'groups',
  CLIENT: 'clientsNew',
  SHIFTS: 'shifts',
  TIMESHEETS: 'timesheets',
  STANDARDTAKS: 'standardTasks',
  SUPPLIES_CLEANINGS: 'supplies_cleanings',
  SUPPLIES_ORDER: 'supply_order',
  SUPPLIES_CATEGORY: 'supplies_category',
  SUPPLIES_ORDER_NOTES: 'supply_order_notes',
  ISSUES: 'issues',
  ADMIN_STAT_DATA_COUNT: 'stat_data',
  NOTIFICATIONS: 'notifications',
  ALERT: 'alerts',
  CHAT_CHANNELS: 'chat_channels',
  CHAT_MESSAGES: 'chat_messages',
  USER_ACTIVITY_LOG: 'user_activity_log',
  ISSUE_NOTIFICATIONS:'issue_notifications',
  APPOINMENTS:'appoinments',
  NOTIFICATION_SETTINGS: 'notification_settings',
  ISSUE_SETTINGS: 'issue_settings',
  APPOINTMENT_SETTINGS: 'appointment_settings',
  CLIENT_SETTINGS: 'client_settings',
  SUPPLIES_SETTINGS: 'supplie_settings',
  SUPPLIES_COMPANY_CATEGORY: 'supplies_company_category',
  SUPPLIES_INDUSTRY: 'supplies_industry',
  STRIPE_EVENT: 'strip_events',
  STRIPE_PRODUCTS: 'strip_products',
  STRIPE_INVOICE: 'strip_invoice',
  STRIPE_SUBSCRIPTION: 'strip_subscription',
  STRIPE_CARDS: "strip_cards",
  STRIPE_CHARGES: "strip_charge",
  SUPPORT: "support",
  HISTORY: 'history',
  SYSTEM_SETTINGS: 'system_settings',
  EMAIL_TRACKING: 'email_tracking',
  PAYMENT_VERIFICATION: 'payment_verification',
};
